import BaseModelFactory from './base.factory'
import ResourceService from './../services/Resource.service'
import Resource from './../models/resource.model'

class ResourceFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search({ search, pagination, order_by, method }, { Service: ResourceService, Model: Resource })
  static findById = async id => await this._findById(id, { Service: ResourceService, Model: Resource })
  static findAllActive = async () =>
    await this._search(
      { search: { active: 1 }, pagination: false, order_by: { created_at: 'DESC' } },
      { Service: ResourceService, Model: Resource }
    )
  static create = payload => this._create(payload, { Service: ResourceService, Model: Resource })
}

export default ResourceFactory
